module.exports = __webpack_public_path__ + "static/2_1_chicken-crossing-3_IT-12ade609a0f09dc58aeebbdcfa27c0ce.svg";